import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import styles from "../../Styles/Itinerary.module.scss";
// import picture_2 from "../../img/Greece/Day 2 Athens.jpeg";
// import picture_3 from "../../img/Greece/Day 3 Athens.jpeg";
// import picture_4 from "../../img/Greece/Day 4 Mt. Olympas.jpeg";
// import picture_5 from "../../img/Greece/Day 5 Thessalonika.jpeg";
// import picture_6 from "../../img/Greece/Day 6 Kavala.jpeg";
// import picture_7 from "../../img/Greece/Day 7 Philippi.jpeg";
// import picture_8 from "../../img/Greece/Day 8 Berea.jpeg";
// import picture_9 from "../../img/Greece/Day 9 Meteora.jpeg";
// import picture_10 from "../../img/Greece/Day 10 Actium.jpeg";
// import picture_11 from "../../img/Greece/Day 11 Corinth.jpeg";
import { IoClose } from "react-icons/io5";
import pictureOne from "./../../img/Germany/Itinerary_1.jpeg";
import pictureTwo from "./../../img/Germany/Itinerary_2.jpeg";
import pictureThree from "./../../img/Germany/Itinerary_3.jpeg";

function ItalyItinerary() {
  //For day 2

  const [boxState, setBoxState] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false
  ]);
  const open = function (i) {
    const copy = [...boxState];
    copy[i] = true;
    setBoxState(copy);
  };
  const close = function (i) {
    const copy = [...boxState];
    copy[i] = false;
    setBoxState(copy);
  };

  const tripMay = [
    {
      day: "Day 1, Tuesday – May 4",
      text: ["Depart the USA."]
    },
    {
      day: "Day 2, Wednesday – May 5",
      text: [
        "Arrive in Berlin, Germany. Get settled into our hotel, rest, and/or explore the surrounding area in the heart of Berlin (overnight in Berlin)."
      ]
    },
    {
      day: "Day 3, Thursday – May 6",
      text: [
        "On our first full day in Germany, we will take a guided tour of Berlin. This will include Checkpoint Charlie, the Brandenburg Gate, and a walk past the Reichstag building which functions as the seat of the federal German parliament. As time permits, we will visit other sites in the city (overnight in Berlin)."
      ]
    },
    {
      day: "Day 4, Friday – May 7",
      text: [
        "In the morning, we will tour the house of the Bonhoeffer family. This is the house where Dietrich Bonhoeffer was arrested by the Gestapo and from where he was taken to prison. In the afternoon, we will drive to Wittenberg (overnight in Wittenberg)."
      ]
    },
    {
      day: "Day 5, Saturday – May 8",
      text: [
        "On this day we will take a guided tour of Wittenberg. This sleepy little town in rural eastern Germany doesn't look like the center of a revolution, but the events that played out here in the 16th Century shook the foundations of Christendom and began the Protestant Reformation. It was here in Wittenberg, Germany, that Martin Luther lived and preached, and on October 31, 1517, he nailed his 95 Theses to the door of the Castle Church where Luther is buried. In addition to visiting the Castle Church, we will also pay a visit to the Town Church where Luther did most of his preaching in Wittenberg (overnight in Wittenberg)."
      ]
    },
    {
      day: "Day 6, Sunday – May 9",
      text: [
        "In the morning, we will drive to Eisleben, the place where Luther was born and where he died. Our visit will include stops at the house where he was born, the church where he was baptized, the church where he preached his last sermon, and the house where he died. In the afternoon, we will visit Buchenwald, one of the largest and most notorious of the Nazi concentration camps (overnight in Erfurt )."
      ]
    },
    {
      day: "Day 7, Monday – May 10",
      text: [
        "In the morning our tour of Erfurt will include a visit to the monastery where Luther first became a monk. In the afternoon, we will drive to the field, near Erfurt, where where the 22-year-old Luther was walking when he fell to the ground in a thunderstorm and promised to become a monk. Late afternoon, we will drive to Eisenach (overnight in Eisenach)."
      ]
    },
    {
      day: "Day 8, Tuesday – May 11",
      text: [
        "In the morning, we will stroll up the hill from the town of Eisenach to the Castle of Wartburg. We will take a guided tour of the castle and see the Luther Room where Martin Luther was imprisoned for approximately 10 months, and where he translated the Bible into German. In the afternoon, we will drive to the small eastern German agricultural community of Waldthurn (overnight near Flossenbürg)."
      ]
    },
    {
      day: "Day 9, Wednesday – May 12",
      text: [
        "In the morning, we will drive the short distance to Flossenbürg, the concentration camp where Dietrich Bonhoeffer was executed by the Nazis. We will tour the camp and discuss the price Bonhoeffer paid to resist the Nazis. In the afternoon, we will drive to Munich where we will spend time exploring the center of the city (overnight in or near Munich)."
      ]
    },
    {
      day: "Day 10, Thursday – May 13",
      text: [
        "On this day we will drive to the Bavarian Alps and to the small but charming town of Mittenwald. Nearby, we will plan to do a little hiking on the Austrian border. If time permits, we may try to visit Neuschwanstein, the most famous castle in Germany (overnight in or near Munich)."
      ]
    },
    {
      day: "Day 11, Friday – May 14",
      text: [
        "After driving to the Munich airport, we will fly back to Berlin (overnight at the Berlin airport)"
      ]
    },
    {
      day: "Day 12, Saturday – May 15",
      text: ["Fly back to the USA"]
    }
  ];
  const tripExample = [
    {
      day: "Day 1",
      text: ["Depart the USA."]
    },
    {
      day: "Day 2",
      text: [
        "Arrive in Berlin, Germany. Get settled into our hotel, rest, and/or explore the surrounding area in the heart of Berlin (overnight in Berlin)."
      ]
    },
    {
      day: "Day 3",
      text: [
        "On our first full day in Germany, we will take a guided tour of Berlin. This will include Checkpoint Charlie, the Brandenburg Gate, and a walk past the Reichstag building which functions as the seat of the federal German parliament. As time permits, we will visit other sites in the city (overnight in Berlin)."
      ]
    },
    {
      day: "Day 4",
      text: [
        "In the morning, we will tour the house of the Bonhoeffer family. This is the house where Dietrich Bonhoeffer was arrested by the Gestapo and from where he was taken to prison. In the afternoon, we will drive to Wittenberg (overnight in Wittenberg)."
      ]
    },
    {
      day: "Day 5",
      text: [
        "On this day we will take a guided tour of Wittenberg. This sleepy little town in rural eastern Germany doesn't look like the center of a revolution, but the events that played out here in the 16th Century shook the foundations of Christendom and began the Protestant Reformation. It was here in Wittenberg, Germany, that Martin Luther lived and preached, and on October 31, 1517, he nailed his 95 Theses to the door of the Castle Church where Luther is buried. In addition to visiting the Castle Church, we will also pay a visit to the Town Church where Luther did most of his preaching in Wittenberg (overnight in Wittenberg)."
      ]
    },
    {
      day: "Day 6",
      text: [
        "In the morning, we will drive to Eisleben, the place where Luther was born and where he died. Our visit will include stops at the house where he was born, the church where he was baptized, the church where he preached his last sermon, and the house where he died. In the afternoon, we will visit Buchenwald, one of the largest and most notorious of the Nazi concentration camps (overnight in Erfurt )."
      ]
    },
    {
      day: "Day 7",
      text: [
        "In the morning our tour of Erfurt will include a visit to the monastery where Luther first became a monk. In the afternoon, we will drive to the field, near Erfurt, where where the 22-year-old Luther was walking when he fell to the ground in a thunderstorm and promised to become a monk. Late afternoon, we will drive to Eisenach (overnight in Eisenach)."
      ]
    },
    {
      day: "Day 8",
      text: [
        "In the morning, we will stroll up the hill from the town of Eisenach to the Castle of Wartburg. We will take a guided tour of the castle and see the Luther Room where Martin Luther was imprisoned for approximately 10 months, and where he translated the Bible into German. In the afternoon, we will drive to the small eastern German agricultural community of Waldthurn (overnight near Flossenbürg)."
      ]
    },
    {
      day: "Day 9",
      text: [
        "In the morning, we will drive the short distance to Flossenbürg, the concentration camp where Dietrich Bonhoeffer was executed by the Nazis. We will tour the camp and discuss the price Bonhoeffer paid to resist the Nazis. In the afternoon, we will drive to Munich where we will spend time exploring the center of the city (overnight in or near Munich)."
      ]
    },
    {
      day: "Day 10",
      text: [
        "On this day we will drive to the Bavarian Alps and to the small but charming town of Mittenwald. Nearby, we will plan to do a little hiking on the Austrian border. If time permits, we may try to visit Neuschwanstein, the most famous castle in Germany (overnight in or near Munich)."
      ]
    },
    {
      day: "Day 11",
      text: [
        "After driving to the Munich airport, we will fly back to Berlin (overnight at the Berlin airport)"
      ]
    },
    {
      day: "Day 12",
      text: ["Fly back to the USA"]
    }
  ];

  const params = useParams();

  let dates = "";
  let trip = [];
  console.log(params.trip);

  switch (params.trip) {
    case "May-2027":
      dates = "May 4 - 15, 2027";
      trip = tripMay;
      break;

    case "trip":
      dates = "";
      trip = tripExample;
      break;
  }

  return (
    <div className="pageContainer">
      <p className="title">Itinerary</p>
      <p className="secondaryTitle">{dates}</p>

      <div className="pictureRow">
        <div>
          <img className="picture" src={pictureOne} alt="Poland town" />
        </div>
        <div className="hide">
          <img className="picture" src={pictureTwo} alt="Poland solt mines" />
        </div>
        <div>
          <img className="picture" src={pictureThree} alt="Polamd mountains" />
        </div>
      </div>

      {trip.map((item, i) => (
        <div key={i} className={styles.IsraelItinerary}>
          <h2 className={styles.dayNumber}>{item.day}</h2>
          <ul className={styles.list}>
            {item.text.map((par, i) => (
              <li className={styles.listItem} key={i}>
                {par}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default ItalyItinerary;
